<template>
  <lu-vbox lu-flex class="app-container">
    <lu-item>
      <PageHeader :title='$t("Custom View")' :hasReload='true' :hasDownLoad='true' @reload='reload'/>
    </lu-item>
    <lu-vbox class="searchBox">
      <lu-hbox class='searchDivTitle pad-in-5' lu-vcenter lu-click @click='searchExpanded=!searchExpanded'>
        <lu-item lu-click class="el-icon-arrow-right blc-icon" style='font-size:0.85rem;' :class='searchExpanded ? "isActive" : ""'  />
        <lu-item>{{ $t('search.search') }} </lu-item>
      </lu-hbox>

      <lu-hbox lu-hcenter class='pad-in-5 mar-t-10 mar-b-10'>
        <lu-item><el-button icon="el-icon-s-home" @click="goHome()">{{ $t('Home') | upperCase }}</el-button></lu-item>
        <lu-item>
          <el-tooltip :disabled="!canGoBack" :effect="styleTooltip" :content="backTooltip" placement="top" >
            <el-button :disabled="!canGoBack" icon="el-icon-back" @click="goBack()">{{ $t('Back') | upperCase }}</el-button>
          </el-tooltip>
        </lu-item>
        <lu-item>
          <el-tooltip :disabled="!canGoForward" :effect="styleTooltip" :content="forwardTooltip" placement="top" >
            <el-button :disabled="!canGoForward" icon="el-icon-right" @click="goForward()">{{ $t('Forward') | upperCase }}</el-button>
          </el-tooltip>
        </lu-item>
      </lu-hbox>
    </lu-vbox>

    <PageTitle :title='currentTitle' />
    <lu-scroll-area lu-flex :scrollbarWidth='10' style='padding-right: 10px;'>
      <el-table
        :data='currentRows'
        fit
        striped
        class='table'
        :row-class-name="tableRowClassName"
        style="width: 100%;"
        @row-dblclick='(row,column) => getDetail(row,column)'
       >
          <el-table-column header-align="center" align='left' v-for='(header, idx) in currentHeader' :key='idx' :label='header.data' show-overflow-tooltip>
            <template slot-scope="scope">
              <template v-if="scope.row.columns && scope.row.columns.length && scope.row.columns[idx]">
                <template v-if="currentData.rows[scope.$index].columns[idx].editable">
                  <el-input autosize v-model="currentData.rows[scope.$index].columns[idx].data" @change="getDetail(scope.row, scope.row.columns[idx])" @keyup.enter.native="getDetail(scope.row, scope.row.columns[idx])" class="custom-input" />
                </template>
                <template v-else>
                  <span>{{ scope.row.columns[idx].data }}</span>
                </template>
              </template>
            </template>
          </el-table-column>
      </el-table>
    </lu-scroll-area>
  </lu-vbox>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseController from '@/controllers/BaseController'
import { LuVbox, LuHbox, LuItem, LuScrollArea } from 'lusis-ui'
import PageHeader from '@/components/PageHeader'
import PageTitle from '@/components/PageTitle'

export default {
  extends: BaseController,
  name: 'customView',
  components: { LuVbox, LuHbox, LuItem, LuScrollArea, PageHeader, PageTitle },
  filters: {
    upperCase(str) {
      return str.toUpperCase()
    }
  },
  data () {
    return {
      searchExpanded: true,
      currentData: {},
      historyFunction: [],
      currentIndex: -1,
      loadingFunction: false
    }
  },
  mounted: function () {
    this.goHome()
  },
  computed: {
    ...mapGetters(['theme']),
    styleTooltip: function () {
      return this.theme !== 'light-theme' ? 'dark' : 'light'
    },
    currentTitle () {
      if (this.currentData && this.currentData.title) {
        return this.currentData.title
      }
      return ''
    },
    currentHeader () {
      if (this.currentData && this.currentData.header) {
        return this.currentData.header
      }
      return []
    },
    currentRows () {
      if (this.currentData && this.currentData.rows) {
        return this.currentData.rows
      }
      return []
    },
    canGoBack () {
      return (this.currentIndex > 0) && !this.loadingFunction
    },
    canGoForward () {
      return (this.currentIndex < this.historyFunction.length - 1) && !this.loadingFunction
    },
    backTooltip () {
      if (this.canGoBack) {
        return this.getFunctionByIndex(this.currentIndex - 1)
      } else {
        return null
      }
    },
    forwardTooltip () {
      if (this.canGoForward) {
        return this.getFunctionByIndex(this.currentIndex + 1)
      } else {
        return null
      }
    }
  },
  methods: {
    getFunction (functionId, updateIndex = false) {
      if (!functionId || this.loadingFunction) return
      this.loadingFunction = true
      return this.$tango.sendFunctionRequest(functionId).then(rep => {
        if (updateIndex) {
          if (this.getFunctionByIndex(this.currentIndex) !== functionId) {
            this.currentIndex++
          }
          // update history function + range
          this.historyFunction[this.currentIndex] = functionId
          this.historyFunction = this.historyFunction.slice(0, this.currentIndex + 1)
        } else {
          this.historyFunction[this.currentIndex] = functionId
        }
        this.currentData = Object.assign({}, rep)
        this.loadingFunction = false
      })
    },
    updateCurrentFunction () {
      this.getFunction(this.getFunctionByIndex(this.currentIndex), false)
    },
    clearHistoryFunction () {
      this.currentIndex = -1
      this.historyFunction = []
    },
    goHome () {
      this.clearHistoryFunction()
      this.getFunction('help', true)
    },
    goBack () {
      if (!this.canGoBack) return
      this.currentIndex--
      this.updateCurrentFunction()
    },
    goForward () {
      if (!this.canGoForward) return
      this.currentIndex++
      this.updateCurrentFunction()
    },
    getFunctionByIndex (index) {
      return (index >= 0 && index < this.historyFunction.length) ? this.historyFunction[index] : ''
    },
    reload () {
      this.updateCurrentFunction()
    },
    getFunctionParams (functionId) {
      return [...functionId.matchAll(/%(.*?)%/g)].map(match => match[1]);
    },
    getRowKeyIndex(row, key) {
      if (!row || !row.columns || !row.columns.length || !key) {
        return -1;
      }
      for (let i = 0; i < row.columns.length; i++) {
        if (row.columns[i] && row.columns[i].key === key) {
          return i;
        }
      }
      return -1;
    },

    getDetail (row) {
      if (row && row.functionId) {
        let functionId = row.functionId
        const params = this.getFunctionParams(functionId)
        if (params.length) {
          params.forEach((param) => {
            const keyIdx = this.getRowKeyIndex(row, param)
            if (keyIdx !==-1 && row.columns[keyIdx]) {
              functionId = functionId.replace('%' + param + '%', row.columns[keyIdx].data)
            }
          })
        }
        this.getFunction(functionId, true)        
      }
    },
    tableRowClassName({ row, rowIndex }) {
      let className = row && row.functionId ? 'dblclick-cursor ' : ''
      if (rowIndex % 2 === 0) {
        className += 'odd-row';
      } else {
        className += 'even-row';
      }
      return className;
    }
  }
}
</script>

<style>
  .custom-input .el-input__inner {
    border: none ! important;
    box-shadow: none !important;
  }
  .dblclick-cursor {
    cursor: pointer;
  }
</style>
